import { Component, Input, OnInit } from '@angular/core';
import { LetterService } from '../../services/letter.service';
import { LetterModel } from '../../models/letter.model';

@Component({
    selector   : 'my-letter',
    template: require('./letter.component.html'),
    styles: [require('./letter.component.scss')],
})

export class LetterComponent implements OnInit{

    @Input('letter') letter:LetterModel;
    state: boolean = false;

    constructor(private letterService:LetterService) {

    }

    ngOnInit(){

    }

    send(){
        if (this.letterService.isSend || this.letterService.state)
            return;
        else {
            this.letterService.error = false;
            this.letter.send();
        }
    }

    close(){
        this.letterService.openPanel = false;
    }

    calculatePrice(){
        this.letter.calculatePrice();
    }

    uploadFile(event: EventTarget){
        let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
        let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
        let files: FileList = target.files;
        this.letter.file = files[0];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/letter/letter.component.ts